<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  details: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const INTERNAL_KEYS = [
  'id',
  'mop',
  'etag',
  'idempotencyKey',
  'externalRef',
  'providerStatus',
  'bookedAt',
  'extensions',
  'warnings',
  'status',
  'type',
];

const entries = computed(() =>
  Object.entries(props.details)
    .filter(
      ([key, value]) =>
        !INTERNAL_KEYS.includes(key) &&
        (typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'boolean')
    )
    .map(([key, value]) => ({ key: key.replace(/_/g, ' '), value }))
);
</script>

<template>
  <div v-if="entries.length" class="space-y-2">
    <p class="text-xs font-medium text-n-slate-11">
      {{ t('CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.DETAILS') }}
    </p>
    <div class="rounded-lg border border-n-weak bg-n-alpha-1 p-3 space-y-2">
      <div
        v-for="entry in entries"
        :key="entry.key"
        class="flex items-baseline justify-between gap-4 text-sm"
      >
        <span class="capitalize text-n-slate-11">{{ entry.key }}</span>
        <span class="text-right text-n-slate-12">{{ entry.value }}</span>
      </div>
    </div>
  </div>
</template>
